import React from 'react';
/**
 * `ButtonRemove` is a thin styled wrapper around the shared `Button` component.
 *
 * It applies secondary button styling plus the `cms-btn-remove` CMS hook class,
 * and includes the `remove-plan-button` class used by the UI.
 */

import Button from '../Button/Button';

type ButtonRemoveProps = {
  name: string;
  text: string;
  disabled?: boolean;
  onClick: (callback?: () => void) => void;
  waitText?: string;
  waitValue?: boolean;
  waitOnClick?: boolean;
  additionalClassNames?: string;
};

export const ButtonRemove = ({
  name,
  text,
  disabled,
  onClick,
  waitText,
  waitValue,
  waitOnClick,
  additionalClassNames
}: ButtonRemoveProps): JSX.Element => {
  let classes = 'button button-secondary remove-plan-button';

  if (additionalClassNames) {
    classes += ` ${additionalClassNames}`;
  }

  classes += ' cms-btn-remove';

  return (
    <Button
      name={name}
      text={text}
      disabled={disabled}
      className={classes}
      onClick={onClick}
      waitValue={waitValue}
      waitText={waitText}
      waitOnClick={waitOnClick}
    />
  );
};
